<div class="mt-4">
  <app-stepper
    [step]="2"
  ></app-stepper>
  <h2 class="mt-5 mt-lg-6 fw-bold" *ngIf="!loading && !loadingRedirect && !skipValuesInDisputeForm">
    {{ 'StepValueInDispute.Title' | translate }} {{ project.name }}
  </h2>
  <div class="lead" *ngIf="!loading && !loadingRedirect && !skipValuesInDisputeForm">
    {{ 'StepValueInDispute.SubTitle' | translate }}
  </div>

  <ng-container *ngIf="!loading && !loadingRedirect && !skipValuesInDisputeForm">
    <ng-container *ngFor="let value of valueInDisuputeRows; index as i; first as isFirst;">
      <app-dispute-box
        [dynamicForm]="dynamicForm"
        [index]="i"
        [valueInDispute]="value"
        [first]="i === 0"
        [isOpen]="getIsDisputeBoxOpen(value, i)"
        [shouldCollapse]="collapseDisputeBoxes[i] || false"
        (openChange)="onDisputeBoxOpenChange(value.id, $event)"
        (removeItem)="removeValueInDispute($event)"
        [fields]="fields"
        [projectShortName]="projectShortName"
        [tokenIdentifier]="tokenIdentifier"
        [sessionToken]="sessionToken"
        [projectSettings]="projectSettings"
        [enableMultipleProductsSelection]="enableMultipleProducts"
        [productSelection]="productSelectionOptions"
        [existingFiles]="existingFiles"
        (disputeBoxValid)="onDisputeBoxValidationChange($event, i)"
      >
      </app-dispute-box>
    </ng-container>

    <div class="mt-3 text-center" *ngIf="activeState()">
      <div class="btn btn-sm btn-primary rounded-3" (click)="addValueInDispute()">
        <i class="fa-solid fa-circle-plus pe-2"></i>
        {{'StepValueInDispute.ButtonAddDispute' | translate}}
      </div>
    </div>
  </ng-container>
  <div class="mt-4 text-end">
    <app-form-button-submit *ngIf="!loading && !loadingRedirect && !skipValuesInDisputeForm"
                            [label]="'General.ButtonContinue' | translate"
                            [icon]="'angle-right'"
                            [active]="isFormValid()"
                            (click)="onSubmit()"
    ></app-form-button-submit>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<ng-template #deleteDisputeConfirmModal>
  <div class="modal-header">
    <h4 class="modal-title">{{ 'General.ConfirmationDelete' | translate }}</h4>
  </div>
  <div class="modal-body">
    <p>{{ 'General.DeleteValueInDisputeConfirmation' | translate }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancelDelete()">{{ 'General.ConfirmationAbbort' | translate }}</button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()">{{ 'General.ConfirmationDelete' | translate }}</button>
  </div>
</ng-template>
